import React from 'react';
import Icon from 'components/atoms/Icon';
import { ErrorMessageProps } from 'types/components.types';
import { ErrorVariant } from 'types/common.types';

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  error, 
  onDismiss, 
  className = '',
  variant = 'danger',
  showIcon = true 
}) => {
  if (!error) return null;

  const variantClasses: Record<ErrorVariant, string> = {
    danger: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800'
  };

  const iconClasses: Record<ErrorVariant, string> = {
    danger: 'text-red-400',
    warning: 'text-yellow-400',
    info: 'text-blue-400'
  };

  const iconNames: Record<ErrorVariant, string> = {
    danger: 'exclamation-triangle',
    warning: 'exclamation',
    info: 'information-circle'
  };

  return (
    <div className={`border rounded-md p-4 ${variantClasses[variant]} ${className}`}>
      <div className="flex">
        {showIcon && (
          <div className="flex-shrink-0">
            <Icon 
              name={iconNames[variant]} 
              className={`h-5 w-5 ${iconClasses[variant]}`} 
            />
          </div>
        )}
        <div className={`${showIcon ? 'ml-3' : ''} flex-1`}>
          <p className="text-sm font-medium">
            {typeof error === 'string' ? error : error.message || 'An unexpected error occurred'}
          </p>
        </div>
        {onDismiss && (
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                onClick={onDismiss}
                className={`inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-opacity-75 ${
                  variant === 'danger' 
                    ? 'text-red-500 hover:bg-red-100 focus:ring-red-600' 
                    : variant === 'warning'
                    ? 'text-yellow-500 hover:bg-yellow-100 focus:ring-yellow-600'
                    : 'text-blue-500 hover:bg-blue-100 focus:ring-blue-600'
                }`}
              >
                <span className="sr-only">Dismiss</span>
                <Icon name="x" className="h-5 w-5" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
